<app-page-header
  title="Häufig gestellte Fragen"
  subtitle="Antworten auf die wichtigsten Themen rund um Coins, Bestellungen und dein Kundenkonto."
  icon="help_outline"
  variant="gradient">
</app-page-header>

<div class="apple-container apple-faq-wrapper apple-slide-up">
  <mat-accordion class="apple-faq-accordion" multi>
    <ng-container *ngIf="faqs$ | async as faqs">
      <mat-expansion-panel *ngFor="let faq of faqs" class="apple-faq-panel apple-card">
        <mat-expansion-panel-header class="apple-faq-header" expandIconPosition="end">
          <mat-panel-title>
            <div class="apple-faq-header-content">
              <div class="apple-faq-icon">
                <mat-icon>help_outline</mat-icon>
              </div>
              <div class="apple-faq-text">
                <span class="apple-faq-question">{{ faq.question }}</span>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="apple-faq-answer" [innerHTML]="faq.answer"></div>
      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>
</div>
